import {
  LineChart,
  Droplets,
  Zap,
  Radio,
  FlaskConical,
  SlidersHorizontal,
  Factory,
  CloudSun,
  Server,
  RadioTower,
  Shield,
  Users,
  Handshake,
  Building2,
  Wrench,
} from 'lucide-react';

const icons = {
  LineChart,
  Droplets,
  Zap,
  Radio,
  FlaskConical,
  SlidersHorizontal,
  Factory,
  CloudSun,
  Server,
  RadioTower,
  Shield,
  Users,
  Handshake,
  Building2,
  Wrench,
};

export const getIcon = (name) => icons[name] || Building2;
